import { Injectable, EventEmitter } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { FormGroup } from "@angular/forms";
export let isDebugMode = environment.isDebugMode

@Injectable()
export class ModalSearchService {

  title: string

  constructor() {
    isDebugMode ? console.log(`constructor()`) : undefined
  }

}
